// function delay(time) {
//   return new Promise(resolve => setTimeout(resolve, time));
// }
// gsap.registerPlugin("ScrollToPlugin", "ScrollTriggerPlugin");

// const sections = document.querySelectorAll(".trigger");

// const scrolling = {
//   enabled: true,
//   events: "scroll,wheel,touchmove,pointermove".split(","),
//   prevent: e => e.preventDefault(),
//   disable() {
//       if (scrolling.enabled) {
//           scrolling.enabled = false;
//           window.addEventListener("scroll", gsap.ticker.tick, {
//               passive: true
//           });
//           scrolling.events.forEach((e, i) => (i ? document : window).addEventListener(e, scrolling.prevent, {
//               passive: false
//           }));
//       }
//   },
//   enable() {
//       if (!scrolling.enabled) {
//           scrolling.enabled = true;
//           window.removeEventListener("scroll", gsap.ticker.tick);
//           scrolling.events.forEach((e, i) => (i ? document : window).removeEventListener(e, scrolling.prevent));
//       }
//   }
// };

// function swapClassByIndex(index = 0, element) {
//   if (element) {
//       if (index == 0) {
//           element.classList.remove('animate-I');
//       } else if (index == 1) {
//           element.classList.add('animate-I');
//           element.classList.remove('animate-II');
//       } else if (index == 2) {
//           element.classList.add('animate-II');
//       }
//   }
// }

// const singleTextBlock = document.querySelectorAll('.single-text-block');
// const logoContainer = document.querySelector('.logo-container');

// // check if we already triggered at least one transition
// var scrolled = false;

// // For storing last element index
// var lastIndex = 0;

// // Go to another section and perform animations
// function goToSection(section, anim, i) {

//   if (scrolling.enabled) {


//       scrolling.disable();
      

//       let triggerEl = section.querySelectorAll('.real-trigger'),
//           triggerIndex = triggerEl[0].dataset.triggerIndex;

//       // zero out opacity for all text blocks if current index does not match last stored index
//       if (lastIndex !== triggerIndex) {
//           singleTextBlock.forEach((block) => {
//               block.classList.remove('opacity-show');
//           });
//       }

//       // on initial load show element without delay and add initial animation for first element
//       if ( !scrolled ) {

//           singleTextBlock[triggerIndex].classList.add('opacity-show');
//           logoContainer.classList.add('animate-O');

//       } else {

//           // wait for animation to 'almost' finish before revealing another text block
//           // avoids ugly text overlaping animation
//           delay(1000).then(
//               () => {
//                   singleTextBlock[triggerIndex].classList.add('opacity-show');
//               }
//           );

//       }

//       // switch animations based on current text block index
//       swapClassByIndex(triggerIndex, logoContainer);

//       // we triggered transition
//       scrolled = true;

//       // store current index as lastIndex
//       lastIndex = triggerIndex;

//       // anim && anim.restart();

//       console.log(i);
//       console.log(innerHeight);


//       gsap.to(window, {
//           scrollTo: {
//               y: section,
//               autoKill: false,
//               ease: "Power3.easeInOut"
//           },
//           onInterrupt: scrolling.disable,
//           onComplete: scrolling.enable,
//           onReverseComplete: scrolling.enable,
//           duration: 1.4,
//           // ease: "none",
//       });

//   }
// }

// /*
// ScrollTrigger.defaults({
//   markers: true
// });
// */

// // may work better than solution bellow
// sections.forEach((section, i) => {
//   ScrollTrigger.create({
//     trigger: section,
//     start: "top bottom-=1",
//     onEnter: () => goToSection(section, false, i)
//   });

//   ScrollTrigger.create({
//     trigger: section,
//     start: "bottom bottom",
//     end: "bottom top+=1",
//     onEnterBack: () => goToSection(section, false, i)
//   });
// });

// /*
// // works pretty well
// sections.forEach((section, i) => {
//   ScrollTrigger.create({
//       trigger: section,
//       start: "top bottom-=1",
//       end: "bottom top+=1",
//       onEnter: () => goToSection(section, false, i),
//       onEnterBack: () => goToSection(section, false, i)
//   });
// });
// */